import { Button, Card } from '@vallourec-ui/vallourec-ui'
import styled from 'styled-components'

export const StyledCard = styled(Card)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  width: 100%;

  gap: ${({ theme }) => theme.spacing[16]};

  &:hover,
  &:focus {
    opacity: 1;
  }
`

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing[10]};
  padding: ${({ theme }) => theme.spacing[0]};
  width: 100%;
  align-self: stretch;
  align-items: flex-start;
  justify-content: flex-end;
  width: 100%;
`

export const StyledButton = styled(Button)`
  background-color: #efeef6;
  border: 1px solid ${({ theme }) => theme.colors['brand-color-primary-5']};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  white-space: nowrap;
  width: ${({ theme }) => theme.spacing[120]};
  &:hover {
    background: ${({ theme }) => theme.colors['brand-color-primary-5']};
    border: 1px solid ${({ theme }) => theme.colors['brand-color-primary-4']};
    color: ${({ theme }) => theme.colors['brand-color-primary-0']};
    box-shadow: none;
  }
  &:active {
    background: ${({ theme }) => theme.colors['brand-color-primary-5']};
    border: 1px solid ${({ theme }) => theme.colors['brand-color-primary-4']};
    color: ${({ theme }) => theme.colors['brand-color-primary-0']};
    box-shadow: none;
  }
  &:focus {
    background: ${({ theme }) => theme.colors['brand-color-primary-5']};
    border: 1px solid ${({ theme }) => theme.colors['brand-color-primary-4']};
    color: ${({ theme }) => theme.colors['brand-color-primary-0']};
    box-shadow: none;
  }
`

export const CardTitle = styled.div`
  border: 1px solid ${({ theme }) => theme.colors['neutral-color-20']};
  border-radius: 8px;
  width: 100%;
  display: flex;
  flex: 1;
  height: 2.5rem;
  justify-content: center;
  align-items: center;
`

export const HeaderContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: repeat(3, auto);
  width: 100%;
`

export const PhotoContainer = styled.div`
  display: flex;
  width: 100%;
  border-radius: 8px;
  height: 5rem;
  justify-content: center;
  align-items: center;
  text-align: center;
`

export const FooterContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(1, auto);
  width: 100%;
  border-radius: 8px;
  justify-content: center;
  align-items: center;
  flex-direction: flex-start;
`

export const StyledImg = styled.img`
  max-width: 100%;
  max-height: 100%;
  width: 100%;
  height: 100%;
  border-radius: 7px;
  transform-origin: center;
  transition-delay: 0ms;

  &:hover,
  &:focus {
    border: 1px solid ${({ theme }) => theme.colors['brand-color-primary-1']};
    opacity: 1;
  }
`
